import React from 'react';

import { useTranslation } from 'react-i18next';
import PageContainer from '../../../components/layout/page-container/PageContainer';
import { useGetUserSubscribers } from '../../../services/redux/api/usersApi';
import withRouter from '../../../hooks/with-router';
import UsersList from '../../../components/reusable/users-list/UsersList';
import { useNotFound } from '../../../hooks/useNotFound';
import { useStyles } from './UserSubscribers.styles';
import theme from '../../../styles/theme';

function UserSubscribers(props) {
  const { params } = props;
  const { t, i18n } = useTranslation();
  const { data: subscribers, isFetching } = useGetUserSubscribers(
    params.userId,
  );
  useNotFound(!isFetching && !subscribers);
  const { classes } = useStyles(theme);

  return (
    <PageContainer title={t('user.subscribers')} backButton>
      <div className={classes.subscribersWrapper}>
        <UsersList users={subscribers} />
      </div>
    </PageContainer>
  );
}

export default withRouter(UserSubscribers);
